"use client";

import useRemoveFromCart from "./removeFromCart";
import useRemovePromo from "./removePromo";
import useUpdateQuantity from "./updateQuantity";
import { useAddPromo } from "./useAddPromo";
import { useFormatItems } from "./useItems";
import useModal from "./useModal";
import useSelection, { useAddToCart } from "./useSelection";

const useCart = () => {
  const { cart, isLoading } = useSelection();

  const modal = useModal("cart", () => {}, true);
  const { addToCart } = useAddToCart();
  const { addPromo } = useAddPromo();
  const { removePromo } = useRemovePromo();
  const { removeItem } = useRemoveFromCart();
  const { updateQuantity } = useUpdateQuantity();
  const { formattedItems: items } = useFormatItems(cart?.items);

  return {
    cart: cart,
    items,
    isLoading,
    addItem: addToCart,
    addPromo,
    removePromo,
    removeItem,
    updateQuantity,
    modal,
    summary: cart?.summary,
  };
};

export type CartHook = ReturnType<typeof useCart>;

export default useCart;
